module.exports = __webpack_public_path__ + "static/media/teygjur.53b14e8e.png";